import { render, staticRenderFns } from "./StudentScore.vue?vue&type=template&id=460cf453&scoped=true"
import script from "./StudentScore.vue?vue&type=script&lang=js"
export * from "./StudentScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460cf453",
  null
  
)

export default component.exports